import { type CaseReducer } from '@reduxjs/toolkit';

import { emptyCredential } from '../initialStates';
import { type SessionState } from '../types';

const loginRejectedCase: CaseReducer<SessionState> = state => {
  state.credentials = emptyCredential;
  state.status = 'notLogged';
  state.isLoading = false;
  state.hasError = true;
};

export { loginRejectedCase };
